module.exports = __webpack_public_path__ + "img/IMG_9916.0498bacb.jpg";